import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { Adjunto } from 'src/app/modelos/file.interface';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { StorageService } from 'src/app/services/storage.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFileComponent),
      multi: true
    }
  ]
})
export class InputFileComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() typeImage: string;

  public onChange = (_: any) => { }
  public onTouch = () => { }

  public name_adjunto: string;
  public isLoad: boolean;
  public adjunto: Adjunto;
  public value: string;
  isDisabled: boolean;

  constructor(private storageService: StorageService) {
    this.isLoad = false;
  }

  ngOnInit(): void {
    if (this.storageService.ifExist('adjuntos')) {
      let adjuntos: Adjunto[] = JSON.parse(this.storageService.getItem('adjuntos'));
      let adjunto: Adjunto = adjuntos.find((adjunto: Adjunto) => adjunto.typeAdjunto == this.typeImage);
      if (adjunto?.isLoad) {
        this.name_adjunto = adjunto.nameAdjunto;
        this.isLoad = adjunto.isLoad;
      }
    }
  }


  eliminarImagen() {
    this.isLoad = false;
    this.name_adjunto = "";
    this.value = "";
    this.clearStorage();
    this.onChange(this.value);
    this.onTouch();
  }

  private clearStorage(){
    let adjuntos: Adjunto[];
    let adjuntoIndex;
    if (this.storageService.ifExist('adjuntos')) {
      adjuntos = JSON.parse(this.storageService.getItem('adjuntos'));
      adjuntoIndex = adjuntos.findIndex((adjunto: Adjunto) => adjunto.typeAdjunto === this.typeImage);
    }

    switch(this.typeImage){
      case 'anverso':
        adjuntos[adjuntoIndex].isLoad = false;
        break;
      case 'reverso':
        adjuntos[adjuntoIndex].isLoad = false;
        break;
      case 'comprobante':
        adjuntos[adjuntoIndex].isLoad = false;
        break;
    }
    this.storageService.setItem('adjuntos', JSON.stringify(adjuntos));
  }

  loading: boolean = false;

  guardaYMuestraImagen(event) {
    this.value = event.target.files[0];
    this.isLoad = true;
    this.name_adjunto = `${event.target.files[0].name}`;
    this.saveAdjunto(this.name_adjunto);
    this.onTouch();
    this.onChange(this.value);

  }

  writeValue(value: any): void {
    if (value) {
      this.value = value || '';
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  saveAdjunto(name: string) {
    if (this.storageService.ifExist('adjuntos')) {
      let adjuntos: Adjunto[] = JSON.parse(this.storageService.getItem('adjuntos'));
      let index = adjuntos.findIndex((adjunto: Adjunto) => adjunto.typeAdjunto == this.typeImage);
      if (index != -1) {
        adjuntos[index].nameAdjunto = name;
      } else {
        adjuntos.push({ nameAdjunto: name, typeAdjunto: this.typeImage, isLoad: false });
      }
      this.storageService.setItem('adjuntos', JSON.stringify(adjuntos));
    } else {
      let adjuntos: Adjunto[] = [];
      adjuntos.push({ nameAdjunto: name, typeAdjunto: this.typeImage, isLoad: false });
      this.storageService.setItem('adjuntos', JSON.stringify(adjuntos));
    }
  }
}
